import { jsx as l, jsxs as W } from "react/jsx-runtime";
import { useMemo as X, useCallback as I } from "react";
import n from "styled-components";
import Y from "../../icons/chevron-down.js";
import Z from "../Checkbox/Checkbox.js";
import _ from "../Chip/Chip.js";
import "../LabelTooltip/LabelTooltip.js";
import ee from "../LabelTooltip/utils.js";
import M from "../Menu/components/MenuItem.js";
import oe from "../TextField/TextField.js";
import te from "./utils/calculateSelectInputPadding.js";
const re = {
  root: "selectRoot",
  select: "selectSelect",
  selectMenu: "selectSelectMenu",
  disabled: "selectDisabled",
  icon: "selectIcon",
  iconOpen: "selectIconOpen",
  outlined: "selectOutlined"
}, k = {
  root: "menuItemRoot",
  selected: "menuItemSelected"
}, ie = {
  root: "menuRoot",
  paper: "menuPaper",
  list: "menuList"
}, le = (e) => ({
  "&& .menuPaper": {
    maxHeight: "300px",
    border: "none",
    boxShadow: `0 4px 20px 0 ${e.primaryShadow}`,
    marginTop: "8px",
    marginBottom: "4px",
    padding: "8px",
    // boxSizing is important when scrollbar is displayed.
    boxSizing: "border-box"
  },
  "& .menuList": {
    // Remove the padding on the list to put it on the paper.
    padding: "0px"
  }
}), ne = n.span.withConfig({
  displayName: "PlaceHolder"
})([
  "color:",
  ";padding:",
  ";line-height:",
  ";"
], ({ theme: e }) => e.text.secondary, ({ $useChips: e }) => e ? "3px 2px" : "0px", ({ $useChips: e }) => e ? "24px" : "18px"), b = n.span.withConfig({
  displayName: "ClearSelection"
})([
  "margin:auto;color:",
  ";"
], ({ theme: e }) => e.primaryFill), C = n(M).withConfig({
  displayName: "StyledMenuItem"
})([
  "&:hover .formControlLabelRoot .checkboxRoot svg,&&&.menuItemSelected:not(.menuItemDisabled) > ",
  ",&&.menuItemRoot.Mui-focusVisible:not(.menuItemDisabled) .formControlLabelRoot .checkboxRoot svg,&&.menuItemRoot.Mui-focusVisible:not(.menuItemDisabled) > ",
  ",&:hover > ",
  "{color:",
  ";}&.menuItemSelected .formControlLabelRoot .checkboxRoot.checkboxChecked{background-color:",
  ";}&.menuItemSelected .formControlLabelRoot .checkboxRoot.checkboxChecked svg{color:",
  ";}"
], b, b, b, ({ theme: e }) => e.colors.white, ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.colors.white), ce = n(Z).withConfig({
  displayName: "StyledCheckbox"
})([
  "&& .checkboxRoot{margin-right:8px;background-color:transparent;}&& .checkboxRoot.checkboxChecked{background-color:",
  ";}&& .checkboxRoot svg{color:",
  ";}&& .checkboxRoot:hover.checkboxRoot{color:",
  ";}&& .checkboxRoot:hover.checkboxRoot:not(:active) svg{color:",
  ";}&& .checkboxRoot:active svg{color:",
  ";}"
], ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.isLightTheme ? e.colors.white : e.text.primary, ({ theme: e }) => e.isLightTheme ? e.colors.white : e.text.primary, ({ theme: e }) => e.isLightTheme ? e.colors.white : e.text.primary), ae = n.div.withConfig({
  displayName: "ChipsContainer"
})([
  "display:flex;flex-wrap:",
  ";overflow:inherit;button{margin:0px;}button ~ button{margin-left:",
  ";}"
], ({ $noWrap: e }) => e ? "nowrap" : "wrap", ({ $noWrap: e }) => e ? "4px" : "0px"), se = n(Y).withConfig({
  displayName: "ArrowDownIcon"
})([
  "width:10px;height:10px;color:",
  ";"
], ({ theme: e }) => e.text.primary), de = n(oe).withConfig({
  displayName: "StyledTextField"
})([
  "&&& .outlinedInputRoot .outlinedInput.selectSelect{min-height:",
  ";white-space:",
  ";padding:",
  ";line-height:",
  ";}&& .outlinedInputRoot .selectIcon{top:calc(50% - 5px);right:12px;transition:transform 0.25s linear;transform:rotate(0deg);}&& .outlinedInputRoot .selectIconOpen{transform:rotate(-180deg);}&& .outlinedInputRoot .selectDisabled{color:",
  ";}"
], ({ $size: e }) => e === "medium" ? "40px" : "32px", ({ $noWrap: e }) => e ? "nowrap" : "normal", ({ $useChips: e, $size: g }) => te({
  $useChips: e,
  $size: g
}), ({ $size: e }) => e === "medium" ? "22px" : "18px", ({ theme: e }) => e.color.text.disabled), me = ({ allowNonSelected: e = !1, autoWidth: g = !1, children: L = void 0, classes: N, className: $ = void 0, defaultValue: d = void 0, displayEmpty: D = !0, emptyText: m = "No Options", IconComponent: A = se, options: o = void 0, ItemsProps: h = void 0, MenuProps: F = void 0, multiple: c = !1, name: a, native: O = !1, nonSelectedText: R, noWrap: f = !0, onChange: v = void 0, onClose: z = void 0, onOpen: P = void 0, open: he, renderValue: S = void 0, SelectProps: T = void 0, SelectDisplayProps: j = void 0, size: H = "small", variant: pe, placeholder: w = void 0, value: i = void 0, useChips: p = !1, useCheckboxes: y = !1, tooltip: E = void 0, label: B = void 0, ...U }) => {
  const q = X(() => {
    const r = [];
    return e && r.push(/* @__PURE__ */ l(C, {
      // @ts-expect-error - TODO: Check if name is used.
      name: `${a}-nonSelectedItem`,
      classes: k,
      value: c ? void 0 : "",
      onClick: c ? (t) => {
        v({
          ...t,
          target: {
            ...t.target,
            value: c ? [] : "",
            name: a
          }
        });
      } : void 0,
      ...h,
      children: /* @__PURE__ */ l(b, {
        children: R
      })
    }, "nonSelectedItem")), (!o || o.length === 0) && m && m.length > 0 && r.push(/* @__PURE__ */ l(M, {
      // @ts-expect-error - TODO: Check if name is used.
      name: `${a}-NothingToDisplay`,
      classes: k,
      disabled: !0,
      ...h,
      children: m
    }, "NothingToDisplay")), o && o.forEach((t) => r.push(/* @__PURE__ */ W(C, {
      /* Use String() as toString() in order to handle null and undefined. */
      // @ts-expect-error - TODO: Check if name is used.
      name: `${a}-${String(t.value)}`,
      classes: k,
      value: t.value,
      ...h,
      children: [
        y && c ? (
          // @ts-expect-error - TODO: Fix typing.
          /* @__PURE__ */ l(ce, {
            checked: i.indexOf(t.value) > -1
          })
        ) : null,
        typeof t.label == "string" ? /* @__PURE__ */ l("span", {
          children: t.label
        }) : t.label
      ]
    }, String(t.value)))), r;
  }, [
    e,
    o,
    m,
    a,
    h,
    R,
    v,
    c,
    y,
    i
  ]), G = I((r) => {
    const t = Array.isArray(r) ? r : [
      r
    ];
    return /* @__PURE__ */ l(ae, {
      $noWrap: f,
      children: t.map((s) => {
        var x;
        const u = ((x = o == null ? void 0 : o.find((V) => V.value === s)) == null ? void 0 : x.label) ?? s;
        return /* @__PURE__ */ l(_, {
          label: u,
          size: "small"
        }, s);
      })
    });
  }, [
    f,
    o
  ]), J = I(() => /* @__PURE__ */ l(ne, {
    $useChips: p,
    children: w
  }), [
    w,
    p
  ]), K = I((r) => (Array.isArray(r) ? r : [
    r
  ]).map((s) => {
    var u;
    return ((u = o == null ? void 0 : o.find((x) => x.value === s)) == null ? void 0 : u.label) ?? s;
  }).join(", "), [
    o
  ]), Q = () => d === void 0 && (i === null || i === "" || i === void 0 || Array.isArray(i) && i.length === 0) ? J : p ? G : y && !S ? K : S;
  return /* @__PURE__ */ l(de, {
    $useChips: p,
    $noWrap: f,
    $size: H,
    name: a,
    className: $,
    select: !0,
    slotProps: {
      select: {
        autoWidth: g,
        classes: {
          ...re,
          ...N
        },
        displayEmpty: D,
        IconComponent: A,
        MenuProps: {
          classes: ie,
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          sx: le,
          ...F
        },
        multiple: c,
        native: O,
        onClose: z,
        onOpen: P,
        value: i ?? (d || ""),
        renderValue: Q(),
        SelectDisplayProps: j,
        ...T
      }
    },
    defaultValue: d,
    value: i ?? (d || ""),
    onChange: v,
    label: ee(B, E),
    ...U,
    children: L || q
  });
};
me.displayName = "Select";
export {
  me as default
};
